<template>
  <div class="wap-navigation">
    <div class="flex-sp">
      <img class="logo" @click="to_page('/')" src="@/assets/imgs/common/logo.png" />
      <img class="logos" @click="close()"  src="@/assets/imgs/wap/close.png" />
    </div>

    <div style="margin-top:.5rem"></div>
    <template v-for="(item,index) in dataList">
      <div style="padding-bottom: 0.4rem;border-bottom: 0.02rem solid rgba(255,255,255,0.0800);margin-bottom: 0.4rem">
        <div class="navigation-ul flex-sp" ><span @click="to_page(item.path)">{{item.name}}</span>
          <template v-if="item.children">
          <img @click="btn_show(index)" v-if="item.show" class="icon-ight" src="@/assets/imgs/wap/add.png" />
          <img @click="btn_show(index)" v-if="!item.show" class="icon-ight" src="@/assets/imgs/wap/open.png" />
          </template>
        </div>

        <div v-show="item.show" style="margin-top: 0.2rem">
          <div class="navigation-li" @click="to_page(items.path)" v-for="items in item.children">{{items.name}}</div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
  export default {
    name: 'wapnavigations',
    props:["tabIndex"],
    data(){
      return{
        dataList:[
          {
            name:"解决方案",
            show:true,
            path:"/solution",
            children:[{
              name:"行业挑战",
              path:"/solution?index=index1"
            },{
              name:"方案优势",
              path:"/solution?index=index2"
            },{
              name:"方案价值",
              path:"/solution?index=index3"
            }]
          },
          {
            name:"产品与服务",
            show:false,
            path:"/product",
            children:[{
              name:"预应力工程全数量检测系统",
              path:"/product?index=1",
            },{
              name:"锚下预应力检测系统",
              path:"/product?index=2",
            },{
              name:"预应力锚索基础试验系统",
              path:"/product?index=3",
            }
              ,{
                name:"智能拉拔系统",
                path:"/product?index=4",
              }
              ,{
                name:"远程监测系统",
                path:"/product?index=5",
              }]
          },
          {
            name:"技术创新",
            show:false,
            path:"/technological",
          },
          {
            name:"典型案例",
            show:false,
            path:"/case",
            children:[{
              name:"高速公路",
              path:"/case?index=4",
            },{
              name:"软岩隧道",
              path:"/case?index=1",
            },{
              name:"铁路桥梁",
              path:"/case?index=2",
            }
              ,{
                name:"特殊桥梁",
                path:"/case?index=3",
              }
              ,{
                name:"边坡工程",
                path:"/case?index=5",
              }   ,{
                name:"基坑工程",
                path:"/case?index=6",
              }]
          },
          // {
          //   name:"新闻中心",
          //   show:false,
          //   path:"/news",
          // },
          {
            name:"关于交达",
            show:false,
            path:"/inRegard"
          },
          {
            name:"联系我们",
            show:false,
            path:"/contactUs",
          },
        ]
      }
    },
    mounted() {
    },
    methods: {
      to_page(path){
        window.location.href=window.location.origin+"/#"+path;
        window.location.reload()
      },
      close(){
        this.$emit("close")
      },
      btn_show(index){
        this.dataList[index].show=!this.dataList[index].show
      }
    },
  }
</script>
<style scoped>
  .wap-navigation{
    top: 0;
    left: 0;
    background-color: #FFFFFF;
    position: fixed;
    width: 100%;
    height:100%;
    padding: 0.4rem 0.6rem;
    box-sizing: border-box;
  }
  .wap-navigation .logo{
    width: 2.6rem;
  }
  .wap-navigation .logos{
    width: 0.4rem;
    object-fit: contain;
  }

  .navigation-ul{
    font-size: 0.32rem;
    font-family: PingFang SC-Bold, PingFang SC;
    font-weight: bold;
    color: #19203B;
  }

  .icon-ight{
    width: 0.36rem;
    object-fit: contain;
  }

  .navigation-li{
    font-size: 0.28rem;
    margin-top: 0.2rem;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #19203B;
  }

  .navigation-code{
    margin-top: 0.4rem;
  }
  .navigation-code .img1{
    width: 1.6rem;
  }

  .navigation-code .sp1{
    margin-left: .2rem;
    font-size: 0.36rem;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
  }

  .navigation-sp2{
    font-size: 0.28rem;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #F0F0F0;
    margin-top: 0.4rem;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/wap/navigation.vue